import { render, staticRenderFns } from "./SavedCartProductGroup.vue?vue&type=template&id=42139db8"
import script from "./SavedCartProductGroup.vue?vue&type=script&lang=js"
export * from "./SavedCartProductGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports